var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.201101 0.701027C-0.0670344 0.970021 -0.0670344 1.40485 0.201101 1.67385L4.52806 5.99993L0.201102 10.326C-0.05929 10.5959 -0.0550001 11.0247 0.209696 11.2902C0.475236 11.5549 0.904059 11.5592 1.17391 11.2988L5.98641 6.48631C6.25455 6.21732 6.25455 5.78249 5.98641 5.5135L1.17391 0.700997C0.904916 0.432861 0.470087 0.432861 0.201093 0.700997L0.201101 0.701027Z",
    fill: "#2D3540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.dde807052782af91191000a1169a120d.svg";
export { ForwardRef as ReactComponent };